'use strict';

import { youtube as youtubeOembed } from '../utils/oembed';

export default function () {
    const SELECTOR = '.js-youtube-thumbnail';

    for (const element of document.querySelectorAll(SELECTOR)) {
        youtubeOembed(element.dataset.youtubeUrl).then(response => {
            let thumbnail = response.thumbnail_url;

            thumbnail = thumbnail.replace('hqdefault.jpg', 'maxresdefault.jpg');

            element.onerror = function () {
                this.src = thumbnail.replace('maxresdefault.jpg', 'hqdefault.jpg');
            };

            element.src = thumbnail;
        });
    }
}
